export class PageRequest {

  public sortFields: string[] = [];
  public sortDirections: string[] = [];
  public sortOrders: number[] = [];
  public page = 0;
  public size = 20;

  setSort(field: string, direction: string, orderNumber: number): PageRequest {
    this.sortFields.push(field);
    this.sortDirections.push(direction);
    this.sortOrders.push(orderNumber);
    return this;
  }

  setPage(page: number): PageRequest {
    this.page = page;
    return this;
  }

  setSize(size: number): PageRequest {
    this.size = size;
    return this;
  }

}
